import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

import { fullGradientColors } from "@/components/AIComponents/AiComponents.style";

const { ui } = constants.colors;
const { heading4Obj, fontFamily, fontSize } = typographyStyles;
const e1Gradient = `linear-gradient(0deg, rgba(255, 255, 255, 0.90) 0%, rgba(255, 255, 255, 0.90) 100%), linear-gradient(102deg, ${fullGradientColors.position0.color} 0%, ${fullGradientColors.position25.color} 25%, ${fullGradientColors.position50.color} 50%, ${fullGradientColors.position100.color} 100%)`;

export const collapseButtonCss: CSSObject = {
  fontWeight: "bold",
  textDecoration: "underline",
};
export const headerCss: CSSObject = {
  borderRadius: "10px 10px 0 0",
  display: "flex",
  justifyContent: "space-between",
  background: e1Gradient,
  padding: "1em",
};
export const headerAndIconCss: CSSObject = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  marginBottom: "12px",
};

export const headingTextCss: CSSObject = {
  color: ui.neutral[700],
  margin: "0",
  ...heading4Obj,
  ...fontFamily.noto,
};

export const taglineCss: CSSObject = {
  color: ui.neutral[700],
  marginTop: "10px",
  marginBottom: "8px",
  ...fontSize.textS,
};
